import { Button, Form, Input, Modal, Spin, Table, Tag } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../constants/service.types';
import { getUpdateStateDevicesReturn, socketEmitEvent } from '../../redux/actions';
import { DragOutlined, SaveOutlined, SearchOutlined, SendOutlined } from '@ant-design/icons';
import TinymceEditor from '../../components/TinymceEditor';
import InputTag from '../../components/InputTag';

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const ModalListDevice = ({ mode, deviceState, open, onClose }) => {
  const [formSendEmail] = Form.useForm();
  const emailContentRef = useRef();
  const [requestId] = useState(new Date().getTime());
  const [page, setPage] = useState(0);
  const [size] = useState(10);
  const [name, setName] = useState(''); // search value
  const [tag, setTag] = useState(''); // search value

  const [isLoading, setIsLoading] = useState(false);
  const [visiblSendMail, setVisiblSendMail] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [dataDeviceSelect, setDataDeviceSelect] = useState();
  const [visiblMaintain, setVisiblMaintain] = useState(false);
  const [dataEditorTable, setDataEditorTable] = useState();
  const [isLoadingSendEmail, setIsLoadingSendEmail] = useState(false);
  const [keyTable, setKeyTable] = useState(Math.random());

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { listCameraByState, listGatewayByState, namespace, updateStateDevices } = useSelector(
    (state) => state
  );

  useEffect(() => {
    setIsLoading(false);
  }, [listCameraByState, listGatewayByState]);

  useEffect(() => {
    setDataDeviceSelect(null);
  }, []);

  useEffect(() => {
    if (updateStateDevices?.serials) {
      setVisiblMaintain(false)
      onClose()
      dispatch(getUpdateStateDevicesReturn());
    }
  }, [updateStateDevices]);

  const getListDeviceByPage = useCallback(() => {
    setIsLoading(true);
    let data = {
      namespace,
      deviceType: mode === 0 ? 'camera' : 'gateway',
      timeRequest: new Date().getTime(),
      state: deviceState,
      page,
      size,
      ...(name && { name }),
      ...(tag && { tag }),
    };
    let dataObj = {
      appServiceType: SERVICE.LIST_DEVICE_BY_STATE,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  }, [
    deviceState,
    dispatch,
    mode,
    name,
    namespace,
    page,
    size,
    tag,
  ]);

  const onCancelSendMail = () => {
    formSendEmail.resetFields()
    setVisiblSendMail(false)
  }

  const onHandleSendEmail = () => {
    setVisiblSendMail(true)
    setIsLoadingSendEmail(true)
    setTimeout(() => {
      setIsLoadingSendEmail(false)
    }, 1000);
  }

  const cameraColumns = [
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('Serial'),
      dataIndex: 'serial',
      key: 'serial',
    },
    {
      title: t('Gateway name'),
      dataIndex: 'gatewayName',
      key: 'gatewayName',
    },
    {
      title: t('Address'),
      dataIndex: 'note',
      key: 'note',
    },
    {
      title: t('Tags'),
      dataIndex: 'tags',
      key: 'tags',
      render: (tags) =>
        tags &&
        tags.split(';').map(
          (tag) =>
            !!tag && (
              <Tag key={tag} style={{ margin: 3 }}>
                {tag}
              </Tag>
            )
        ),
    },
  ];

  const gatewayColumns = [
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('Serial'),
      dataIndex: 'serial',
      key: 'serial',
    },
    {
      title: t('Address'),
      dataIndex: 'note',
      key: 'note',
    },
    {
      title: t('Tags'),
      dataIndex: 'tags',
      key: 'tags',
      render: (tags) =>
        tags &&
        tags.split(';').map(
          (tag) =>
            !!tag && (
              <Tag key={tag} style={{ margin: 3 }}>
                {tag}
              </Tag>
            )
        ),
    },
  ];

  useEffect(() => {
    getListDeviceByPage();
  }, [getListDeviceByPage]);

  const handleSearch = (values) => {
    setName(values.name);
    setTag(values.tag);
    setPage(0);
  };

  const handleOnClose = (e, deviceItem) => {
    e.preventDefault();
    setDataDeviceSelect(dataDeviceSelect?.filter(item => item?.serial !== deviceItem?.serial))
  }

  const onCancelMaintain = () => {
    setVisiblMaintain(false)
  }

  const onHandleMaintain = () => {
    setVisiblMaintain(true)
  }

  const onSubmitMaintain = (datas) => {
    let data = {
      namespace,
      serials: datas?.map(item => item?.serial)?.join(';'),
      state: 2
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_STATE_DEVICES,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    }
    dispatch(socketEmitEvent(dataObj));
  }

  const handleOnSend = (value) => {
    let data = {
      namespace,
      emails: value?.emails?.join(';') ?? '',
      emailTitle: value?.emailTitle ?? '',
      emailContent: emailContentRef?.current?.getContent() ?? '',
    };
    let dataObj = {
      appServiceType: SERVICE.SEND_EMAIL_NOTIFICATION,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    }
    dispatch(socketEmitEvent(dataObj));
    setVisiblSendMail(false)
    setDataDeviceSelect(null)
    setDataEditorTable(null)
    setKeyTable(Math.random())
    formSendEmail.resetFields()
  }

  return (
    <Modal
      title={`List ${mode === 0 ? 'camera' : 'gateway'} ${deviceState === 0 ? 'offline' : 'online'
        }`}
      visible={open}
      onCancel={onClose}
      width="75vw"
      footer={null}
      style={{ top: 50 }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Form
          initialValues={{ name: '', tag: '' }}
          onFinish={handleSearch}
          layout="inline"
          style={{ marginBottom: 20 }}
        >
          <Form.Item label={t('Name')} name="name">
            <Input />
          </Form.Item>
          <Form.Item label={t('Tag')} name="tag">
            <Input />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" icon={<SearchOutlined />}>
              {t('Search')}
            </Button>
          </Form.Item>
        </Form>
        {dataDeviceSelect?.length > 0 && (
          <div>
            <Button
              onClick={() => onHandleMaintain()}
              style={{ marginRight: '16px' }}
              icon={<DragOutlined />}
            >
              {t('Move to maintain')}
            </Button>
            <Button
              onClick={() => onHandleSendEmail(dataDeviceSelect)}
              icon={<SendOutlined />}
            >
              {t('Send Email')}
            </Button>
          </div>
        )}
      </div>
      <Table
        style={{ overflow: 'auto' }}
        loading={isLoading}
        key={keyTable}
        dataSource={
          mode === 0 ? (
            listCameraByState?.devices?.map((camera) => ({
              ...camera,
              key: camera.serial,
            }))
          ) : (
            listGatewayByState?.devices?.map((gateway) => ({
              ...gateway,
              key: gateway.serial,
            }))
          )
        }
        rowSelection={deviceState === 0 ? {
          preserveSelectedRowKeys: true,
          onChange: (keys, row) => {
            setDataDeviceSelect(row)
            if (row?.length > 0) {
              const data = row?.map(item => `<tr class="ant-table-row ant-table-row-level-0" data-row-key=${item?.serial ?? ''}>
              <td class="ant-table-cell">${item?.name ?? ''}</td>
              <td class="ant-table-cell">${item?.serial ?? ''}</td>
              <td class="ant-table-cell">Offline</td>
              <td class="ant-table-cell">${item?.note ?? ''}</td>
              </tr>`)

              setDataEditorTable(`<table>
              <thead class="ant-table-thead">
              <tr>
              <th class="ant-table-cell" style="text-align: left;">Name</th>
              <th class="ant-table-cell" style="text-align: left;">Serial</th>
              <th class="ant-table-cell" style="text-align: left;">State</th>
              <th class="ant-table-cell" style="text-align: left;">Address</th>
              </tr>
              </thead>
              <tbody class="ant-table-tbody">
              ${data?.join('') ?? ''}
              </tbody>
              </table>`)
            } else {
              setDataEditorTable('')
            }
          },
        } : undefined}
        columns={mode === 0 ? cameraColumns : gatewayColumns}
        pagination={{
          total:
            mode === 0 ? listCameraByState?.total : listGatewayByState?.total,
          current: page + 1,
          onChange: (page) => {
            setPage(page - 1);
          },
        }}
      />
      <Modal
        visible={visiblSendMail}
        title={t('Send Email')}
        onCancel={() => onCancelSendMail()}
        footer={null}
        width="70vw"
        style={{ top: 50 }}
      >
        {visiblSendMail && (
          <Spin spinning={isLoadingSendEmail}>
            <div className="send-mail-component">
              <Form
                form={formSendEmail}
                {...layout}
                name="form_edit_gateway"
                onFinish={(value) => handleOnSend(value)}
              >
                <Form.Item
                  name="emailTitle"
                  label={t('Title')}
                  rules={[
                    {
                      required: true,
                      message: t('Please input the title!'),
                    },
                    {
                      max: 80,
                      message: t('Please input up to 80 characters!'),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="emails"
                  className="edit-email"
                  label={t('Email')}
                  style={{ borer: '1px solid #434343', borderRadius: '2px' }}
                >
                  <InputTag numberTag={3} nameAdd="Add email" />
                </Form.Item>
                <Form.Item
                  label={t('Content')}
                >
                  <TinymceEditor
                    id="emailContent"
                    key="emailContent"
                    editorRef={emailContentRef}
                    value={dataEditorTable ?? ''}
                    heightEditor="400px"
                  />
                </Form.Item>
                <div className="btn-update-gateway">
                  <Button onClick={() => onCancelSendMail()}>{t('Cancel')}</Button>
                  <Form.Item shouldUpdate={true}>
                    {() => (
                      <Button
                        icon={<SaveOutlined />}
                        htmlType="submit"
                        loading={isLoad}
                        type="primary"
                        disabled={
                          !formSendEmail.isFieldsTouched(true) ||
                          formSendEmail.getFieldsError().filter(({ errors }) => errors.length)
                            .length
                        }
                      >
                        {t('Send')}
                      </Button>
                    )}
                  </Form.Item>
                </div>
              </Form>
            </div>
          </Spin>
        )}
      </Modal>
      <Modal
        visible={visiblMaintain}
        title={t('Move to maintain')}
        onCancel={() => onCancelMaintain()}
        footer={null}
        width="35vw"
        style={{ top: 50 }}
      >
        {visiblMaintain && (
          <div className="maintain-component">
            <div style={{ marginBottom: "20px" }}>
              {dataDeviceSelect?.map(deviceItem => (
                <div style={{ marginBottom: '5px' }}>
                  <Tag
                    closable
                    onClose={(e) => handleOnClose(e, deviceItem)}
                  >
                    {deviceItem?.serial ? `${deviceItem?.name} (${deviceItem?.serial})` : ''}
                  </Tag>
                </div>
              ))}
            </div>
            <div className="btn-update-gateway">
              <Button onClick={() => onCancelMaintain()}>{t('Cancel')}</Button>
              <Form.Item shouldUpdate={true}>
                {() => (
                  <Button
                    icon={<SaveOutlined />}
                    type="primary"
                    disabled={
                      !dataDeviceSelect?.length
                    }
                    onClick={() => onSubmitMaintain(dataDeviceSelect)}
                  >
                    {t('Update')}
                  </Button>
                )}
              </Form.Item>
            </div>
          </div>
        )}
      </Modal>
    </Modal>
  );
};

export default ModalListDevice;
